<template>
<v-layout column fluid fill-height>
    <v-flex wrap>
        <v-flex v-if="(!HaveSelectedPlant && !MapOffline) || LoadingPlantGeoData" id="mapLoading">
            <v-card>
                <v-progress-linear indeterminate color="primary" height="15"></v-progress-linear>
            </v-card>
        </v-flex>
        <v-card min-height="600px" min-width="100px" height="100%">
            <v-flex id="plantSelector">
                <v-layout row>
                <v-flex class="select">
                    <v-select background-color="rgba(255, 255, 255, 0.65)"
                            color="primary" 
                            full-width
                            v-model="SelectedView" 
                            dense 
                            :items="Views" 
                            label="View"></v-select>  
                     </v-flex>     
                    <v-flex class="select">
                        <v-select background-color="rgba(255, 255, 255, 0.65)" prepend-inner-icon="access_time" color="primary" full-width v-model="SelectedRefreshInterval" dense label="Refresh" :items="RefreshIntervals" @change="onRefreshChanged"></v-select>
                    </v-flex>
                    <v-flex>
                        <v-btn color="primary" icon @click="resizeMap(!Fullscreen)">
                            <v-icon v-if="!Fullscreen">fullscreen</v-icon>
                            <v-icon v-if="Fullscreen">fullscreen_exit</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex>
                        <v-menu v-if="ShowPlantSelector && !MapOffline">
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" v-on="on">Plant</v-btn>
                            </template>
                            <v-list dense>
                                <v-list-tile :disabled="LoadingPlantGeoData" v-for="item in Plants" :key="item.PlantID" @click="PlantSelectorInputChanged(item.PlantID)">
                                    <v-list-tile-title>{{ item.PlantName }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-flex>

            <div v-if="HaveSelectedPlant && !MapOffline" id="map"></div>

            <div v-if="MapOffline" id="mapOffline">
                <v-alert :value="true" type="warning">You're currently not online. Go online to view this map.</v-alert>
            </div>

            <v-bottom-sheet v-model="DisplayLocationDetailsDrawer" :inset="$vuetify.breakpoint.lgAndUp" @keydown.esc="DisplayLocationDetailsDrawer = false">
                <v-flex xs12 text-xs-center>
                    <template v-if="LoadingAdditionalLocationData">
                        <v-card>
                            <v-divider></v-divider>
                            <v-progress-linear indeterminate color="primary" height="15"></v-progress-linear>
                            <v-divider></v-divider>
                        </v-card>
                    </template>
                    <template v-else-if="this.SelectedView === this.ViewEnum.Harvest">
                        <v-card>
                            <v-card-title class="title font-weight-bold white--text primary">{{ LocationSelected.DivisionName }}: {{ LocationSelected.LocationName }}</v-card-title>
                            <v-divider></v-divider>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md6 lg5 xl4>
                                    <v-list dense>
                                        <v-list-tile>
                                            <v-list-tile-content class="LocationDataLabels">Area ({{ LocationSelected.AreaDisplay }}):</v-list-tile-content>
                                            <v-list-tile-content class="align-end">
                                                <span v-if="!LocationSelected.TotalRows">{{ LocationSelected.TotalArea }}</span>
                                                <span v-else>{{ LocationSelected.TotalArea }} ({{ LocationSelected.TotalRows }} rows, {{ LocationSelected.TotalBushes }} bushes)</span>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-list-tile v-for="(item, i) in LocationVarieties" :key="i">
                                            <v-list-tile-content v-if="i == 0" class="LocationDataLabels">Varieties:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">
                                                <span v-if="item.Rows > 0 || item.Bushes > 0">{{ item.Name }} ({{ item.Rows }} rows, {{ item.Bushes }} bushes)</span>
                                                <span v-else>{{ item.Name }}</span>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-list-tile v-if="LocationSelected.LastPickedDate">
                                            <v-list-tile-content class="LocationDataLabels">Last Pick:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">Date ({{ this.LocationSelected.LastPickedDate | formatDate }})
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        
                                        <v-list-tile v-if="LocationSelected.LastPickedDate">                                        
                                            <v-list-tile-content class="align-end">
                                                <span>
                                                    Days Ago ({{ FormatedDaysAgo }})
                                                </span>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-list-tile v-if="LocationSelected.LastPickedDate">                                        
                                            <v-list-tile-content class="align-end">
                                                <span>
                                                    Totals ({{ LocationSelected.LastPickedTotalKgs }} kg, {{ Math.round(LocationSelected.LastPickedTotalTrays || 0) }} trays)
                                                </span>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-list-tile v-if="LocationSelected.LastPickedDate">
                                            <v-list-tile-content class="align-end"><span>Yield ({{ FormatedLastPickYield }} / {{ LocationSelected.AreaDisplay }})</span>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <SeasonTotals v-if="LocationSelected.LocationID > 0" :locationID="LocationSelected.LocationID"></SeasonTotals>
                                    </v-list>
                                </v-flex>

                                <v-flex xs12 sm7 md7 lg8 xl9>
                                    <v-container v-if="HaveTeamData" class="TeamContainer ma-0 pa-0">
                                        <v-layout row>
                                            <v-flex v-for="data in LocationSelected.TeamData" :key="data.SessionID" shrink>
                                                <v-card class="TeamCard">
                                                    <v-card-title class="subheading font-weight-bold">Team: {{ data.TeamName }}</v-card-title>
                                                    <v-divider></v-divider>
                                                    <v-list dense>
                                                        <v-list-tile>
                                                            <v-list-tile-content>Variety:</v-list-tile-content>
                                                            <v-list-tile-content class="align-end">{{ data.ProductVarietyName }}</v-list-tile-content>
                                                        </v-list-tile>
                                                        <v-list-tile>
                                                            <v-list-tile-content>Harvest Totals:</v-list-tile-content>
                                                            <v-list-tile-content class="align-end">{{ data.TotalKgs | formatNumberTo2Decimals }} kg, {{ Math.round(data.TotalTrays || 0) }} trays</v-list-tile-content>
                                                        </v-list-tile>
                                                        <v-list-tile>
                                                            <v-list-tile-content>Seconds:</v-list-tile-content>
                                                            <v-list-tile-content class="align-end">{{ data.TotalSeconds | formatNumberTo2Decimals }} kg</v-list-tile-content>
                                                        </v-list-tile>
                                                        <v-list-tile>
                                                            <v-list-tile-content>Picker Hours:</v-list-tile-content>
                                                            <v-list-tile-content class="align-end">{{ data.TotalPickingHours | formatNumberTo2Decimals }} hour(s)</v-list-tile-content>
                                                        </v-list-tile>
                                                        <v-list-tile>
                                                            <v-list-tile-content>Average Pick Rate:</v-list-tile-content>

                                                            <v-list-tile-content class="align-end">{{ data.AveragePickRate | formatNumberTo2Decimals }} {{ data.PickRateUnit }}/hour</v-list-tile-content>
                                                        </v-list-tile>
                                                        <v-list-tile>
                                                            <v-list-tile-content>Quality Score:</v-list-tile-content>
                                                            <v-list-tile-content class="align-end">{{ data.QualityScore | formatNumberTo2Decimals }}</v-list-tile-content>
                                                        </v-list-tile>
                                                        <v-list-tile>
                                                            <v-list-tile-content>Berry Weight:</v-list-tile-content>
                                                            <v-list-tile-content class="align-end">{{ data.BerryWeight | formatNumberTo2Decimals }}g</v-list-tile-content>
                                                        </v-list-tile>
                                                        <v-list-tile>
                                                            <v-list-tile-content></v-list-tile-content>
                                                            <v-list-tile-content class="align-end">
                                                                <v-btn color="success" class="mr-0" @click="NavigateToTeamsPage(LocationSelected.PlantID, data.TeamID)">See More</v-btn>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-list>
                                                </v-card>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </template>
                    <template v-else-if="this.SelectedView === this.ViewEnum.Spray">
                        <NuPointSprayView :locationSelected="LocationSelected"></NuPointSprayView>
                    </template>
                    <template v-else-if="this.SelectedView === this.ViewEnum.Maintenance">
                        <LocationMaintenanceView 
                            :locationSelected="LocationSelected" 
                            @onTeamSelected="NavigateToTeamsPage(LocationSelected.PlantID, $event)">
                        </LocationMaintenanceView>
                    </template>
                </v-flex>
            </v-bottom-sheet>
            <v-bottom-sheet v-model="showScoutingOverview" :inset="$vuetify.breakpoint.lgAndUp" @keydown.esc="showScoutingOverview = false">
                <ScoutingOverview v-if="showScoutingOverview" :id="scoutingSpotCheckObservationID"></ScoutingOverview>
            </v-bottom-sheet>
            <v-bottom-sheet v-model="showTrapDetails" :inset="$vuetify.breakpoint.lgAndUp" @keydown.esc="showTrapDetails = false">
                <TrapDetail v-if="showTrapDetails" :id="trapID"></TrapDetail>
            </v-bottom-sheet>
        </v-card>
    </v-flex>
    <v-flex v-if="HaveSelectedPlant && !MapOffline && this.SelectedView === this.ViewEnum.Harvest" shrink class="text-xs-center">
        <v-chip class="normal" text-color="white">Normal(No Pick)</v-chip>
        <v-chip class="rosteredButNotStarted" text-color="white">Rostered but not started</v-chip>
        <v-chip class="pickinLastMin" text-color="white">Active (picked in last 3 hours)</v-chip>
        <v-chip class="sessionAlert" text-color="white">Pick Rate/Quality/Seconds Alert Active</v-chip>
        <v-chip class="pickInLastHour" text-color="white">Picked earlier in the day (last 24 hours)</v-chip>
    </v-flex>
    <v-flex v-if="HaveSelectedPlant && !MapOffline && this.SelectedView === this.ViewEnum.Spray" shrink class="text-xs-center">
        <v-chip class="spray-none">No Active Spray</v-chip>
        <v-chip class="spray-active-part">Active Spray (part day)</v-chip>
        <v-chip class="spray-active-full">Active Spray (all day)</v-chip>
    </v-flex>
    <v-flex v-if="HaveSelectedPlant && !MapOffline && this.SelectedView === this.ViewEnum.Maintenance" shrink class="text-xs-center">
        <v-chip class="maintenance-active">Threshold Breach</v-chip>
        <v-chip class="maintenance-none">Scouting <v-img class="ml-2" :src="require('@/assets/Scout.png')" width="25px"></v-img></v-chip>
        <v-chip class="maintenance-none">Trap <v-img class="ml-2" :src="require('@/assets/Trap.png')" width="25px"></v-img></v-chip>                
        <v-chip class="maintenance-expired">Trap Expired <v-img class="ml-2" :src="require('@/assets/TrapExpired.png')" width="25px"></v-img></v-chip>
    </v-flex>
</v-layout>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import plantApi from '../../api/plantApi'
import locationApi from '../../api/locationApi'
import moment from "moment";
import extent from 'turf-extent';
import LocationMaintenanceView from "@/components/maps/LocationMaintenanceView.vue";
import NuPointSprayView from "@/components/maps/NuPointSprayView.vue";
import SeasonTotals from "@/components/maps/SeasonTotals.vue";
import ScoutingOverview from '@/components/maps/ScoutingOverview.vue';
import TrapDetail from '@/components/maps/TrapDetail.vue';

export default {
    components: {
        LocationMaintenanceView,
        SeasonTotals,
        NuPointSprayView,
        ScoutingOverview,
        TrapDetail
    },
    timer: null,
    data: () => ({
        showScoutingOverview: false,
        showTrapDetails: false,
        trapID: null,
        scoutingSpotCheckObservationID: null,
        viewColors: {
            0: {
                'fill-color': {
                    property: 'LocationStatusValue',
                    stops: [
                        [0, '#3498db'], //Blue Normal
                        [1, '#3bf30d'], //Green Pick At last 24hrs
                        [2, '#3bf30d'], //Green Pick At last 3hrs
                        [3, 'yellow'],  //Yellow Rostered but not started
                        [4, '#e74c3c']  //Red Session Alert
                    ]
                },
                'fill-opacity': {
                    property: 'LocationStatusValue',
                    stops: [
                        [0, 0.1], //blue
                        [1, 0.5], //Pick At last 24hrs
                        [2, 1],   //Green Pick At last 3hrs
                        [3, 0.5], //Rostered but not started
                        [4, 1.0]  //Session Alert
                    ]
                },
                'line-color': {
                    property: 'LocationStatusValue',
                    stops: [
                        [0, '#3498db'], //Blue Normal
                        [1, '#3498db'], //Green Pick At last 24hrs
                        [2, '#3498db'], //Green Pick At last 3hrs
                        [3, '#3498db'], //Yellow Rostered but not started
                        [4, '#3498db']  //Red Session Alert
                    ]
                }
            },
            1: {
                'fill-color': {
                    property: 'NuPointSprayStatusValue',
                    stops: [
                        [0, '#3bf30d'],  //No active spray
                        [1, '#e74c3c'],  //Full affected day
                        [2, '#edce77'],  //Part affected day
                    ]
                },
                'fill-opacity': {
                    property: 'NuPointSprayStatusValue',
                    stops: [
                        [0, 0.25], //No active spray                   
                        [1, 1.0],   //Full affected day
                        [2, 1.0],   //Part affected day
                    ]
                },
                'line-color': {
                    property: 'NuPointSprayStatusValue',
                    stops: [
                        [0, '#3bf30d'], //No active spray
                        [1, '#3bf30d'], //Full affected day
                        [2, '#3bf30d'], //Part affected day
                    ]
                }
            },
            2: {
                'fill-color': {
                    property: 'MaintenanceStatusValue',
                    stops: [
                        [0, 'yellow'],  //No Maintenance
                        [1, 'red'], //Red Threshold breach
                    ]
                },
                'fill-opacity': {
                    property: 'MaintenanceStatusValue',
                    stops: [
                        [0, 0.1], //No Maintenance                        
                        [1, 0.5], //Red Threshold breach
                    ]
                },
                'line-color': {
                    property: 'MaintenanceStatusValue',
                    stops: [
                        [0, 'orange'], //No Maintenance
                        [1, 'orange'], //Red Threshold breach
                    ]
                }
            }
        },        
        Map: {},
        DisplayLocationDetailsDrawer: false,
        LoadingAdditionalLocationData: false,
        LocationSelected: {},
        Plants: [],
        PlantSelected: {},
        PlantPolygonGeoJSONData: null,
        PlantPointGeoJSONData: null,
        Markers: [],
        MapOffline: false,
        LoadingPlantGeoData: false,
        Fullscreen: false,
        SelectedRefreshInterval: {
            value: 0
        },
        RefreshIntervals: [{
                text: "Never",
                value: 0,
                selected: true
            },
            {
                text: "1 Minute",
                value: 1
            },
            {
                text: "2 Minutes",
                value: 2
            },
            {
                text: "5 Minutes",
                value: 5
            },
            {
                text: "10 Minutes",
                value: 10
            },
            {
                text: "30 Minutes",
                value: 30
            }
        ],
        ViewEnum: {
            Harvest: 0,
            Spray: 1,
            Maintenance: 2
        },
        SelectedView: { value: -1 }
    }),
    watch: {
        async SelectedView(newVal, oldVal) {
            if (newVal != oldVal) {
                await this.refreshMapSource(this.Map, this.PlantPolygonGeoJSONData, this.PlantPointGeoJSONData, false);
            }
        }
    },
    computed: {
        ShowPlantSelector: function () {
            return (this.Plants.length > 1);
        },
        HaveSelectedPlant: function () {
            return (this.PlantSelected && this.PlantSelected.PlantID > 0);
        },
        LocationVarieties: function () {
            if (this.LocationSelected && this.LocationSelected.Varieties) {
                return this.LocationSelected.Varieties;
            } else {
                return [];
            }
        },
        HaveTeamData: function () {
            if (this.LocationSelected && this.LocationSelected.TeamData && this.LocationSelected.TeamData.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        FormatedDaysAgo() {
            if(this.LocationSelected) {
                return moment().diff(moment(this.LocationSelected.LastPickedDate), 'days');
            }

            return "";
        },
        FormatedLastPickYield() {
            if(this.LocationSelected && this.LocationSelected.LastPickedYield) {
               return (Math.round(this.LocationSelected.LastPickedYield * 100) / 100).toString() + " kg";
            }

            return "";
        },
        showMaintenance() {
            return this.$store.getters["UserStore/isAuthorised"]({accessRights: [{PlantID: this.PlantSelected.PlantID, Access:'Pest and Disease'}]})
                || this.$store.getters["UserStore/isAuthorised"]({accessRights: [{PlantID: this.PlantSelected.PlantID, Access:'Crop Work Portal Access'}]})
        },
        Views: function () {
            if (this.showMaintenance) {
                return [{
                            text: "Harvest",
                            value: this.ViewEnum.Harvest,
                            selected: true
                        },
                        {
                            text: "Spray",
                            value: this.ViewEnum.Spray
                        },
                        {
                            text: "Pest & Disease",
                            value: this.ViewEnum.Maintenance
                        }
                    ];
            } else {
                return [{
                        text: "Harvest",
                        value: this.ViewEnum.Harvest,
                        selected: true
                    },
                    {
                        text: "Spray",
                        value: this.ViewEnum.Spray
                    }
                ];
            }
        },
    },
    methods: {
        async PlantSelectorInputChanged(p_PlantID) {
            this.PlantSelected = this.Plants.find(function (element) {
                return element.PlantID == p_PlantID;
            });
            await this.GetPlantGeoJSONData(p_PlantID);
            this.SetupMap();
        },
        async onRefreshChanged(interval) {
            let l_this = this;

            if (this.$options.timer) {
                clearInterval(this.$options.timer);
            }

            if (interval > 0) {
                this.$options.timer = setInterval(async () => {
                    await l_this.GetPlantGeoJSONData(l_this.PlantSelected.PlantID);
                    await l_this.refreshMapSource(l_this.Map, l_this.PlantPolygonGeoJSONData, l_this.PlantPointGeoJSONData, false);
                    console.log("Tick");
                }, interval * 60 * 1000);
            }
        },
        async GetPlantGeoJSONData(p_PlantID) {
            try {
                this.LoadingPlantGeoData = true;
                this.PlantPolygonGeoJSONData = await plantApi.getPlantPolygonGeoData(p_PlantID);
                this.PlantPointGeoJSONData = await plantApi.getPlantPointGeoData(p_PlantID);
            } catch (err) {
                this.PlantSelected = null;
                this.HideMap();
            } finally {
                this.LoadingPlantGeoData = false;
            }
        },
        async LocationClicked(p_LocationProps) {
            if (this.SelectedView === this.ViewEnum.Harvest) {  
                this.LoadingAdditionalLocationData = true;
                this.DisplayLocationDetailsDrawer = true;

                var l_locationData = await locationApi.getTodaysHarvestOverview(p_LocationProps.LocationID);
                this.LocationSelected = l_locationData;
                
                this.LoadingAdditionalLocationData = false;
            } else if(this.SelectedView === this.ViewEnum.Spray) {
                this.DisplayLocationDetailsDrawer = true;
                this.LoadingAdditionalLocationData = true;

                this.LocationSelected = await locationApi.getTodaysNuPointSprayOverview(p_LocationProps.LocationID);

                this.LoadingAdditionalLocationData = false;
            }
        },
        async PointClicked(pointProps) {
            if (pointProps.Type == "Scout") {
                this.scoutingSpotCheckObservationID = pointProps.ID;
                this.showScoutingOverview = true;
            }

            if (pointProps.Type == "Trap") {
                this.trapID = pointProps.ID;
                this.showTrapDetails = true;
            }
        },
        NavigateToTeamsPage(p_plantID, p_teamID) {
            let l_date = moment().format('YYYYMMDD');
            window.location.href = "/" + process.env.VUE_APP_OLD_HMS_ROOT + "/Modules/Plants/Teams.aspx?PlantID=" + p_plantID + "&TeamID=" + p_teamID + "&DKey=" + l_date;
        },
        SetupMap() {
            if (this.HaveSelectedPlant) {
                mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
                let l_plant = this.PlantSelected;
                let l_this = this;

                // Clear all child elements
                let parent = document.getElementById('map');
                while (parent.firstChild) {
                    parent.removeChild(parent.firstChild);
                }

                this.Map = new mapboxgl.Map({
                    container: 'map',
                    style: 'mapbox://styles/mapbox/satellite-v9',
                    minzoom: 1.3,
                    center: l_plant.Center,
                    zoom: 14
                });

                if (l_this.PlantPolygonGeoJSONData) {
                    this.Map.on('load', function () {
                        // Setup Datasource and Layers
                        l_this.refreshMapSource(l_this.Map, l_this.PlantPolygonGeoJSONData, l_this.PlantPointGeoJSONData, true);
                    });

                    // When a click event occurs on a feature in the states layer, open a popup at the
                    // location of the click, with description HTML from its properties.
                    l_this.Map.on('click', 'locations-layer', function (e) {
                        l_this.LocationClicked(e.features[0].properties);
                    });

                    // Change the cursor to a pointer when the mouse is over the states layer.
                    l_this.Map.on('mouseenter', 'locations-layer', function () {
                        l_this.Map.getCanvas().style.cursor = 'pointer';
                    });

                    // Change it back to a pointer when it leaves.
                    l_this.Map.on('mouseleave', 'locations-layer', function () {
                        l_this.Map.getCanvas().style.cursor = '';
                    });

                    // When a click event occurs on a feature in the states layer, open a popup at the
                    // location of the click, with description HTML from its properties.
                    l_this.Map.on('click', 'points-labels', function (e) {
                        l_this.PointClicked(e.features[0].properties);
                    });

                    // Change the cursor to a pointer when the mouse is over the states layer.
                    l_this.Map.on('mouseenter', 'points-labels', function () {
                        l_this.Map.getCanvas().style.cursor = 'pointer';
                    });

                    // Change it back to a pointer when it leaves.
                    l_this.Map.on('mouseleave', 'points-labels', function () {
                        l_this.Map.getCanvas().style.cursor = '';
                    });
                }              
            }
        },
        async refreshMapSource(map, polygonDatasource, pointDatasource, fitToBounds = false) {

            map.loadImage(require('@/assets/Scout.png'), (error, image) =>
            {
                if (!map.hasImage('Scout')) {
                    map.addImage('Scout', image);
                }
            });

            map.loadImage(require('@/assets/Trap.png'), (error, image) =>
            {
                if (!map.hasImage('Trap')) {
                    map.addImage('Trap', image);
                }
            });

            map.loadImage(require('@/assets/TrapExpired.png'), (error, image) =>
            {
                if (!map.hasImage('TrapExpired')) {
                    map.addImage('TrapExpired', image);
                }
            });

            // Remove all markers
            this.Markers.forEach(marker => {
                marker.remove();                
            });

            if (map.getLayer("locations-layer")) {
                map.removeLayer("locations-layer");
            }

            if (map.getLayer("locations-borders")) {
                map.removeLayer("locations-borders");
            }

            if (map.getLayer("locations-labels")) {
                map.removeLayer("locations-labels");
            }

            if (map.getLayer("points-labels")) {
                map.removeLayer("points-labels");
            }

            if (map.getSource('Polygon_Data')) {
                map.removeSource('Polygon_Data')
            }

            if (map.getSource('Point_Data')) {
                map.removeSource('Point_Data')
            }

            map.addSource('Polygon_Data', {
                "type": "geojson",
                "data": polygonDatasource
            });

            map.addSource('Point_Data', {
                "type": "geojson",
                "data": pointDatasource
            });

            if (fitToBounds) {
                // Setup Fit to bounds
                let features = polygonDatasource.features
                    .filter(x => x.geometry != null);

                if (features.length > 0) {
                    let featureCollection = {
                        'type': 'FeatureCollection',
                        'features': features
                    };

                    //Get bounds of polygons
                    let orgBbox = extent(featureCollection);
                    map.fitBounds(orgBbox, {
                        padding: 70
                    });
                }
            }

            this.setupLayers(map);
        },
        async setupLayers(map) {
            //Use default value if one hasn't been loaded. Occurs on initial page load
            if (this.SelectedView === undefined || this.SelectedView.value < 0)
                this.SelectedView = this.ViewEnum.Harvest;

            //Fill Layer
            map.addLayer({
                'id': 'locations-layer',
                'type': 'fill',
                'source': "Polygon_Data",
                'layout': {},
                'paint': {
                    'fill-color': this.viewColors[this.SelectedView]['fill-color'],
                    'fill-opacity': this.viewColors[this.SelectedView]['fill-opacity']
                }
            });

            //Border Layer
            map.addLayer({
                "id": "locations-borders",
                "type": "line",
                "source": "Polygon_Data",
                "layout": {},
                "paint": {
                    "line-color": this.viewColors[this.SelectedView]['line-color'],
                    "line-width": 1.5
                }
            });

            //Labels layer
            map.addLayer({
                'id': 'locations-labels',
                'type': 'symbol',
                "source": "Polygon_Data",
                "layout": {
                    "text-field": ['format',
                        ['get', 'LocationName'], {
                            'font-scale': 0.8
                        }
                    ],
                    "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                    "text-offset": [0, 0],
                    "text-anchor": "top"
                },
                "paint": {
                    "text-color": "#ecf0f1"                    
                }
            });

            // Show Traps and Scout Issues as points in the maintenance view only
            if (this.SelectedView === this.ViewEnum.Maintenance) {
                // Points layer
                map.addLayer({
                    'id': 'points-labels',
                    'type': 'symbol',
                    'source': 'Point_Data',
                    'layout': {
                                // get the icon name from the source's "icon" property
                                // concatenate the name to get an icon from the style's sprite sheet
                                //'icon-image': ['concat', ['get', 'Icon'], 'garden-15'],
                                'icon-image': ['get', 'Image'],
                                'icon-size': 0.7,                                
                                'icon-offset': [0, -30],
                                'icon-allow-overlap': true,                                                        
                                // get the title name from the source's "title" property
                                'text-field': ['format',
                                    ['get', 'Title'], {
                                        'font-scale': 0.8
                                    }
                                ],
                                'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                                'text-offset': [0, 0],
                                'text-anchor': 'top'
                            },
                    'paint': {
                        'text-color': '#ecf0f1'                        
                    }
                });
            }
        },
        HideMap() {
            this.MapOffline = true;
        },
        resizeMap(fullscreen) {
            this.$root.$emit("resizeMap", fullscreen);
            this.Fullscreen = fullscreen;
            this.PlantSelectorInputChanged(this.PlantSelected.PlantID);
        }
    },
    async mounted() {
        //get all plants that the user has "view plant data" access rights to
        try {
            this.Plants = await plantApi.getAllPlants();

            //Auto select first plant
            if (this.Plants && this.Plants.length > 0) {
                this.PlantSelected = this.Plants[0];
                await this.GetPlantGeoJSONData(this.PlantSelected.PlantID);                
                this.SetupMap();
            } else {
                this.HideMap();
            }
        } catch (err) {
            this.HideMap();
        }
    }
}
</script>

<style>
@import 'https://api.mapbox.com/mapbox-gl-js/v2.8.2/mapbox-gl.css';

#map {
    position: relative;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    min-height: 600px;
}

#plantSelector {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 5;
}

.TeamCard {
    min-width: 260px;
}

.NuPointCardLabel {
    font-weight: bold !important;
}

.NuPointCardRow {
    width: 50% !important;
    display: flex !important;
}

.TeamContainer {
    overflow-x: scroll;
}

.LocationDataLabels {
    min-width: 100px;
}

.normal {
    background: rgba(52, 152, 219, 0.5) !important;
    border-color: rgba(52, 152, 219, 1);
    border-width: 2px;
    border-style: solid;
    color: black !important;
}

.maintenance-none {
    background: white !important;
    border-color:gray !important;
    border-width: 2px;
    border-style: solid;
    color: black !important;
}

.maintenance-active {
    background: rgb(255, 0, 0, 0.6) !important;
    border-color:orange !important;
    border-width: 2px;
    border-style: solid;
    color: black !important;
}

.maintenance-expired {
    background: white !important;
    border-color: #b71c1c !important;
    border-width: 2px;
    border-style: solid;
    color: black !important;
}

.rosteredButNotStarted {
    background: #fabb0d80 !important;
    border-color: rgba(52, 152, 219, 1) !important;
    border-width: 2px;
    border-style: solid;
    color: black !important;
}

.pickinLastMin {
    background: #3bf30d !important;
    border-color: rgba(52, 152, 219, 1) !important;
    border-width: 2px;
    border-style: solid;
    color: black !important;
}

.pickInLastHour {
    background: rgba(59, 243, 13, 0.5) !important;
    border-color: rgba(52, 152, 219, 1) !important;
    border-width: 2px;
    border-style: solid;
    color: black !important;
}

.sessionAlert {
    background: rgb(231, 76, 60) !important;
    border-color: rgba(52, 152, 219, 1) !important;
    border-width: 2px;
    border-style: solid;
    color: black !important;
}

.spray-none {
    background: rgba(59, 243, 13, 0.5) !important;
    border-color:  #3bf30d  !important;
    border-width: 2px;
    border-style: solid;
    color: black !important;
}

.spray-active-part {
    background: #edce77 !important;
    border-color:  #3bf30d ;
    border-width: 2px;
    border-style: solid;
    color: black !important;
}

.spray-active-full {
    background: #e74c3c !important;
    border-color:  #3bf30d ;
    border-width: 2px;
    border-style: solid;
    color: black !important;
}

.select {
    width: 185px;
}
</style>
